import { BaseRouteService } from 'core/services';

class NikoPatientRouteService extends BaseRouteService {
    constructor() {
        super('niko-patients');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,excludeMasterPatients,facilityId,itemCategoryId,dosDateFrom,dosDateTo,billingValidation}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    sync() {
        return super.update(this.base + '/sync');
    }

    updatePatientInformation(resource) {
        return super.update(this.base + '/update-patient-information/{id}', resource);
    }

    rentalsCapped(resource) {
        return super.update(this.base + '/rentals-capped/{id}', resource);
    }

    hasIvpole(resource) {
        return super.update(this.base + '/has-iv-pole/{id}', resource);
    }
    
    checkExisting(resource) {
        return super.create(this.base + '/check-existing', resource);
    }

    resolveScenario(resource) {
        return super.create(this.base + '/resolve-scenario', resource);
    }

    createWithTemplates(resource) {
        return super.create(this.base + '/create-with-templates', resource);
    }

    getExistingInsurance(id) {
        return super.get(this.base + '/existing-insurance/{id}', id);
    }
}

export default NikoPatientRouteService;